<template>

    <v-dialog>
        <v-btn round depressed small slot="activator"><v-icon color="#099AB1">add_circle</v-icon><span>REGISTRAR CONTATO</span></v-btn>
        <v-card>
            <v-card-title>
                <h5 class="text-uppercase text-xs-right">Registrar Contato</h5>
            </v-card-title>
            <v-card-text>
            <v-layout row>
                <v-flex xs12>
                    <span>Qual foi o resultado da ação?</span>
                </v-flex>
            </v-layout>

            <v-layout row>
                <v-flex xs12>
                    <v-radio-group :mandatory="true">
                        <v-radio value="radio-1" color="#099AB1">
                            <template v-slot:label>
                                <span class="radio">Contato Realizado</span>
                            </template>
                        </v-radio>
                        <v-radio value="radio-2" color="#099AB1">
                            <template v-slot:label>
                                <span class="radio">Tentativa de Contato</span>
                            </template>
                        </v-radio>
                    </v-radio-group>
                </v-flex>
            </v-layout>

            <v-layout row>
                <v-flex xs12>
                    <span>Qual foi o meio?</span>
                </v-flex>
            </v-layout>


            <v-layout row>
                <v-btn-toggle>
                <v-flex x12>
                    <v-btn flat fab><v-icon medium>phone</v-icon></v-btn>

                    <v-btn flat fab><v-icon medium>fab fa-whatsapp</v-icon></v-btn>
                </v-flex>
                </v-btn-toggle>
            </v-layout>


            <v-layout row>
                <v-flex xs12>
                    <span>Como você avalia?</span>
                </v-flex>
            </v-layout>

            <v-layout row>
                <v-btn-toggle>
                <v-flex x12>
                    <v-btn flat fab><v-icon medium>far fa-thumbs-up</v-icon></v-btn>

                    <v-btn flat fab><v-icon medium>far fa-thumbs-down</v-icon></v-btn>
                </v-flex>
                </v-btn-toggle>
            </v-layout>

            <v-layout row>
                <v-flex xs12>
                    <span>Qual foi a data?</span>
                </v-flex>
            </v-layout>

            <v-layout row>
                <v-flex xs12>
                    <v-menu>

                        <v-text-field :value="dataRegistro | filtraData" slot="activator" label="Data" prepend-icon="date_range"></v-text-field>
                        <v-date-picker v-model="dataRegistro" color="#099AB1"></v-date-picker>
                    </v-menu>
                </v-flex>
            </v-layout>

            <v-layout row justify-center>
                <v-card flat>
                    <v-btn round outline small class="text-lowercase" color="#099AB1">salvar</v-btn>
                </v-card>
            </v-layout>

        </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { format } from 'date-fns';

export default {
  data() {
    return {
      dataRegistro: null,
    };
  },
  filters: {
    filtraData(value) {
      if (value) {
        return format(value, 'DD/MM/YYYY');
      }
    },
  },
};
</script>

<style>
.radio{
    font-size: 14px;
}
.v-btn-toggle--selected{
    box-shadow: none;
}

</style>
